import { render, staticRenderFns } from "./billingDetail.vue?vue&type=template&id=2e2f8654"
import script from "./billingDetail.vue?vue&type=script&lang=js"
export * from "./billingDetail.vue?vue&type=script&lang=js"
import style0 from "./billingDetail.vue?vue&type=style&index=0&id=2e2f8654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports